// Department headers a comm is filed under, in inbox order. Mirrors the tech
// server's config/commsDepartments.js (and the FSM client's copy) -- change all
// three together. A message with no header is shown under General.
export const COMMS_DEPARTMENTS = [
  { key: 'hr', label: 'HR' },
  { key: 'finance', label: 'Finance' },
  { key: 'training', label: 'Training' },
  { key: 'communications', label: 'Communications' },
  { key: 'social', label: 'Social' },
  { key: 'ops', label: 'OPS' },
  { key: 'fleet', label: 'Fleet' },
  { key: 'stock', label: 'Stock & Warehouses' },
  { key: 'iso', label: 'ISO' },
  { key: 'hs', label: 'H&S' },
];

export const GENERAL = { key: 'general', label: 'General' };

export const deptLabel = (key) => (COMMS_DEPARTMENTS.find((d) => d.key === key) || GENERAL).label;

// Split an inbox into department sections, in header order, General last.
// Every header is returned (empty ones too) so the tabs don't shift about;
// General only appears when something is actually filed there.
export function splitByDepartment(messages) {
  const byKey = new Map([...COMMS_DEPARTMENTS, GENERAL].map((d) => [d.key, []]));
  for (const m of messages || []) (byKey.get(m.department) || byKey.get(GENERAL.key)).push(m);
  return [...COMMS_DEPARTMENTS, GENERAL]
    .map((d) => {
      const items = byKey.get(d.key);
      return { ...d, messages: items, unread: items.filter((m) => !m.read_at).length };
    })
    .filter((d) => d.key !== GENERAL.key || d.messages.length);
}
